module.exports = __webpack_public_path__ + "static/media/close_white.5304e4e2.svg";